<script setup lang="ts">
import ProgressFrame from '../layout/ProgressFrame.vue';
import ProjectTile from '../../components/ProjectTile.vue';
import ProjectNotFound from '../../components/ProjectNotFound.vue';
import { useProjectStore } from '../../stores/projectStore';

const props = defineProps<{
  projectId: number;
}>();

const projectStore = useProjectStore();
const project = projectStore.getProjectById(props.projectId);
</script>

<template>
  <ProgressFrame pageClass="subsection-page">
    <template #title>Select the site to commission</template>
    <div class="content">
      <template v-if="project">
        <ProjectTile :project="project" :canEdit="true" :canAddSite="false" colorScheme="dark" />
      </template>

      <template v-else>
        <ProjectNotFound />
      </template>
    </div>
  </ProgressFrame>
</template>
